import { Node } from "../../node.js";
/**
 * @public
 */
export function hasInclusiveDescendant(predicate, options = Node.Traversal.empty) {
    return (node) => node.inclusiveDescendants(options).some(predicate);
}
//# sourceMappingURL=has-inclusive-descendant.js.map